<div class="modal get-payment">
  <div class="model-container">
    <div class="modal-header">
      <h3 class="modal-heading" translate *ngIf="paymentsLoaded && paymentMethods?.length === 0 && !data?.paymentMethodId">payment-modal.no-cards-title</h3>
      <h3 class="modal-heading" translate *ngIf="paymentsLoaded && paymentMethods?.length === 0 && !!data?.paymentMethodId">payment-modal.no-other-cards-title</h3>
      <h3 class="modal-heading" translate *ngIf="!paymentsLoaded || paymentMethods?.length > 0">payment-modal.select-payment</h3>
      <img class="modal-close" (click)="closeDialog()" src="/assets/icon/primary-close.svg" alt="close-icon" width="28"
        height="28">
    </div>
   
    <div class="modal-body" *ngIf="paymentsLoaded && paymentMethods?.length > 0">
      <p class="smaller" translate>payment-modal.select-from</p>
       <div class="loading" *ngIf="!paymentsLoaded">
      <h5 class="progress-title" >Loading<span class="dot"></span>
        <span class="dot"></span><span class="dot"></span>
    </h5>
    </div>
      <div class="contents" [class.input-error]="displayRequiredMsg">
        <ng-container *ngFor="let methodItem of paymentMethods">
          <div class="highlight-card" [class.error]="displayRequiredMsg && !selectedMethod" [class.expired]="methodItem.expired" (click)="selectCard(methodItem)"
            [class.last-item]="methodItem.id === paymentMethods[paymentMethods.length - 1].id">
            <div class="custom-checkbox">
              <div class="checkbox">
                <input title="{{methodItem?.instrument?.brand}}" type="radio"
                  [checked]="methodItem.id === selectedMethod?.id" name="paymentCard" [id]="methodItem.id"
                  [value]="methodItem" [disabled]="methodItem?.expired">
                <label [for]="methodItem.id"></label>
              </div>
            </div>
            <div class="details">
              <p class="smallest top"><b>{{methodItem?.instrument?.brand| uppercase}}</b> <b
                  translate>payment-modal.ending-in</b> <b>{{methodItem?.instrument?.lastDigits}}</b></p>
              <p class="caption expiry"><span translate>payment-modal.exp-date</span>
                {{methodItem?.instrument?.expiryMonth}}/{{methodItem?.instrument?.expiryYear}}</p>
              <p class="caption" *ngIf="methodItem?.expired" translate>payment-modal.expired</p>
            </div>
          </div>
        </ng-container>
      </div>
      <label class="validation-message" *ngIf="displayRequiredMsg" translate>
        payment-modal.select-payment-required
      </label>
      <p class="smaller note" translate>payment-modal.to-manage <a (click)="goToShopify()" translate>payment-modal.customer-portal</a></p>
      <div class="modal-actions">
        <button class="button primary" aria-label="update" translate (click)="done()">payment-modal.update</button>
        <a (click)="closeDialog()" translate>retrieve-pin.cancel</a>
      </div>
    </div>
    <!--User has only one active card and it is already used for autopay (it will be excluded from paymentMethods)-->
    <div class="modal-body no-payments" *ngIf="paymentsLoaded && paymentMethods?.length === 0 && !!data?.paymentMethodId">
      <div id="no-payments">
        <p class="smaller" translate>payment-modal.no-other-cards-message</p>
      </div>
      <div class="modal-actions">
        <button class="button primary" (click)="goToShopify()" translate>payment-modal.add-card</button>
        <button class="button tertiary" (click)="closeDialog()" translate>retrieve-pin.cancel</button>
      </div>
    </div>
    <!--User has no saved cards at all-->
    <div class="modal-body no-payments" *ngIf="paymentsLoaded && paymentMethods?.length === 0 && !data?.paymentMethodId">
      <div id="no-payments">
        <p class="smaller" translate>payment-modal.no-cards-message</p>
      </div>
      <div class="modal-actions">
        <button class="button primary" (click)="goToShopify()" translate>payment-modal.add-card</button>
        <button class="button tertiary" (click)="closeDialog()" translate>retrieve-pin.cancel</button>
      </div>
    </div>
  </div>
</div>